<template>
  <div
    v-if="show"
    class="page-options"
  >
    <a
      :title="itemidDisplay"
      href="javascript:"
      class="page-option-menu-btn"
      @click="toggleMenu()"
    >
      <font-awesome-icon
        :icon="iconGear"
        class="icon icon-gear"
        title="Page Options"
      />
    </a>

    <ul
      v-if="showMenu"
      class="node-options"
    >
      <li
        v-for="link in localTasks"
        :key="link.title"
        class="node-option"
      >
        <a
          :class="link.class"
          @click.prevent="execLocalTask(link)"
        >
          <span class="icon-container">
            <font-awesome-icon
              :icon="link.icon"
              class="icon"
              fixed-width
            />
          </span>
          <span class="text">
            {{ link.title }}
          </span>
        </a>
      </li>
      <li class="node-option node-id">
        <b-input-group>
          <b-form-input
            :value="itemidDisplay"
            disabled
          />
          <b-input-group-append>
            <b-btn
              variant="primary"
              @click="copyStringToClipboard(itemidDisplay)"
            >
              Copy
            </b-btn>
          </b-input-group-append>
        </b-input-group>
        <small
          v-if="copied"
          class="success"
        >
          Copied</small>
      </li>
    </ul>
  </div>
</template>

<script>
import {pageMixin} from '../local-tasks-common'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCog,
  faFile,
  faPencilAlt,
  faEye
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faCog,
  faFile,
  faPencilAlt,
  faEye
)

export default {
  mixins: [
    pageMixin
  ],
  props: {
    itemid: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data: function() {
    return {
      copied: false,
      showMenu: false
    }
  },
  computed: {
    iconGear() { return 'cog' },
    iconDefault() { return 'file' },
    iconPen() { return 'pencil-alt' },
    iconEye() { return 'eye' }
  },
  created() {
    this.$eventHub.$on('hideLocalTaskMenus', () => {
      this.showMenu = false
    })
  },
  methods: {
    copyStringToClipboard(string) {
      if (typeof document !== 'undefined') {
        this.copied = false
        let el = document.createElement('textarea')
        el.value = string
        el.setAttribute('readonly', '')
        el.style = {position: 'absolute', left: '-9999px'}
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        this.copied = true
      }
    },
    toggleMenu() {
      if (this.showMenu) {
        this.$eventHub.$emit('hideLocalTaskMenus')
      }
      else {
        this.$eventHub.$emit('hideLocalTaskMenus')
        this.showMenu = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@scss/custom.scss";

.page-options {
  position: absolute;
  z-index: 100;
  top: 1em;
  right: -2em;

  .btn.btn-primary {
    margin-top: 0 !important;
    padding: .1em 1.2em !important;
  }

  .page-option-menu-button {
    border-radius:3px;
    border-color:var(--main-local-tasks-background-color);
    &:hover {
      border-color:var(--main-local-tasks-highlight-background-color);
    }
  }

  a {
    transition: ease-in-out all .3s;
    border: 1px solid var(--main-border-color);
    padding: .5em 1em;
    background: var(--main-local-tasks-background-color);
    display: block;
    border-radius:3px;

    .icon-gear {
      transition: ease-in-out all .3s;
      color: var(--main-local-tasks-text-color) !important;
    }
    &:hover {
      background: var(--main-local-tasks-highlight-background-color);
      border-color:var(--main-local-tasks-highlight-background-color);
      text-decoration: none;
      .icon-gear {
        transform: rotate(350deg);
      }
    }
  }

  .node-options {
    position: absolute;
    top: 2.6em;
    right: 0;
    z-index: 100;
    text-align: left;
    min-width: 16em;
    background: var(--main-local-tasks-drop-down-background-color);
    padding: 1.5em 1em;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    .node-option {
      margin: 0;
      display: block;
      overflow: hidden;
      &.node-id {
        small.success {
          display: block;
          padding: 1rem 0;
          text-align: center;
        }
      }
      a {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        background: var(--main-local-tasks-text-color);
        color: var(--main-local-tasks-background-color);
        &:hover {
          background: var(--main-local-tasks-background-color);
          color: var(--main-local-tasks-text-color);
        }
        .icon-container {
          flex: 1;
          width: 4em;
        }
        span.text {
          flex: 3;
          padding-left: 1em;
        }
      }
      a {
        display: block;

      }
      &:not(:last-child) {
      margin-bottom:.5rem;
      }
    }
  }
}
</style>
